export const theme = {
	typography: {
		fontFamily: "Josefin Sans",
		fontSize: 16,
		fontWeightLight: 400,
		fontWeightRegular: 400,
		fontWeightMedium: 600,
		h1: {
			fontFamily: "Crimson Pro",
			fontSize: "clamp(1.2rem, 8vw, 2.8rem)",
			fontWeight: 400,
			lineHeight: 1,
			textTransform: "none !important"
		},
		h2: {
			fontFamily: "Crimson Pro",
			fontSize: "1.7rem",
			fontWeight: 400,
			lineHeight: 1.1,
			textTransform: "none !important"
		},
		h3: {
			fontFamily: "Crimson Pro",
			fontSize: "1rem",
			fontWeight: 400,
			textTransform: "none !important"
		},
		h4: {
			fontFamily: "Crimson Pro",
			fontSize: "1rem",
			fontWeight: 400
		},
		h5: {
			fontFamily: "Crimson Pro",
			fontSize: "1rem",
			fontWeight: 400,
			lineHeight: 1.2
		},
		h6: {
			fontFamily: "Crimson Pro",
			fontSize: "1rem",
			fontWeight: 400,
			lineHeight: 1.2
		},
		subtitle1: {
			fontSize: "1.1rem",
			fontWeight: 700,
			lineHeight: 1
		},
		body1: {
			fontSize: "1rem",
			lineHeight: 1.5
		},
		body2: {
			fontSize: "1rem",
			lineHeight: 1.37
		},
		button: {
			fontSize: "1.2rem",
			fontWeight: 600,
			lineHeight: 1
		},
		caption: {
			fontSize: "0.9rem",
			lineHeight: 1.37
		},
		overline: {
			fontSize: "0.8rem",
			lineHeight: 1,
			fontWeight: 600
		}
	},
	palette: {
		primary: {
			main: "#9B8678",
			contrastText: "#FFFFFF"
		},
		secondary: {
			main: "#ADB95D",
			contrastText: "#ffffff"
		},
		background: {
			header: {
				appBar: "#9B8678",
				pageTitle: "#9B8678",
				avatar: "#FFFFFF"
			},
			footer: {
				bar: "#ADB95D"
			},
			default: "#FFFFFF",
			drawer: "#F5F3F1",
			menuTree: "#9B8678",
			paper: "#f5f5f5",
			teaser: "#FFFFFF",
			light: "#F5F3F1",
			input: "#F5F3F1",
			text: "#3D3D3D",
			bookmark: "#9B8678",
			bookmarkActive: "#ADB95D",
			allergenIcon: "#ADB95D",
			infoAZItem: "#9B8678",
			pwaAlert: "#9B8678",
			contactOverlay: "#FFFFFF",
			socialMediaItem: "#FFFFFF",
			menuForm: "#F5F3F1"
		},
		foreground: {
			header: {
				avatar: "#9B8678"
			},
			contact: {
				label: "#9B8678"
			},
			footer: {
				navigation: "#FFFFFF",
				navigationHover: "#535F08",
				navigationSelected: "#535F08"
			},
			menu: {
				navigation: "#3D3D3D",
				navigationHover: "#9B8678",
				navigationSelected: "#9B8678"
			},
			overlay: "#FFFFFF",
			bookmark: "#ffffff",
			socialMediaItem: "#ADB95D"
		},
		text: {
			dark: "#3D3D3D",
			primary: "#9B8678",
			divider: "#9B8678",
			gradient: {
				from: "rgba(255, 255, 255, 0.74)",
				to: "#ffffff"
			}
		},
		divider: "rgba(145, 158, 171, 0.24)",
		menuToggle: "#ffffff",
		elementHeadline: "#9B8678",
		lateCheckOut: "#658BC8",
		greenLiving: "#ADB95D"
	},
	shadows: [
		"none",
		"0px 2px 1px -1px rgba(145, 158, 171, 0.2),0px 1px 1px 0px rgba(145, 158, 171, 0.14),0px 1px 3px 0px rgba(145, 158, 171, 0.12)",
		"0px 3px 1px -2px rgba(145, 158, 171, 0.2),0px 2px 2px 0px rgba(145, 158, 171, 0.14),0px 1px 5px 0px rgba(145, 158, 171, 0.12)",
		"0px 3px 3px -2px rgba(145, 158, 171, 0.2),0px 3px 4px 0px rgba(145, 158, 171, 0.14),0px 1px 8px 0px rgba(145, 158, 171, 0.12)",
		"0px 2px 4px -1px rgba(145, 158, 171, 0.2),0px 4px 5px 0px rgba(145, 158, 171, 0.14),0px 1px 10px 0px rgba(145, 158, 171, 0.12)",
		"0px 3px 5px -1px rgba(145, 158, 171, 0.2),0px 5px 8px 0px rgba(145, 158, 171, 0.14),0px 1px 14px 0px rgba(145, 158, 171, 0.12)",
		"0px 3px 5px -1px rgba(145, 158, 171, 0.2),0px 6px 10px 0px rgba(145, 158, 171, 0.14),0px 1px 18px 0px rgba(145, 158, 171, 0.12)",
		"0px 4px 5px -2px rgba(145, 158, 171, 0.2),0px 7px 10px 1px rgba(145, 158, 171, 0.14),0px 2px 16px 1px rgba(145, 158, 171, 0.12)",
		"0px 5px 5px -3px rgba(145, 158, 171, 0.2),0px 8px 10px 1px rgba(145, 158, 171, 0.14),0px 3px 14px 2px rgba(145, 158, 171, 0.12)",
		"0px 5px 6px -3px rgba(145, 158, 171, 0.2),0px 9px 12px 1px rgba(145, 158, 171, 0.14),0px 3px 16px 2px rgba(145, 158, 171, 0.12)",
		"0px 6px 6px -3px rgba(145, 158, 171, 0.2),0px 10px 14px 1px rgba(145, 158, 171, 0.14),0px 4px 18px 3px rgba(145, 158, 171, 0.12)",
		"0px 6px 7px -4px rgba(145, 158, 171, 0.2),0px 11px 15px 1px rgba(145, 158, 171, 0.14),0px 4px 20px 3px rgba(145, 158, 171, 0.12)",
		"0px 7px 8px -4px rgba(145, 158, 171, 0.2),0px 12px 17px 2px rgba(145, 158, 171, 0.14),0px 5px 22px 4px rgba(145, 158, 171, 0.12)",
		"0px 7px 8px -4px rgba(145, 158, 171, 0.2),0px 13px 19px 2px rgba(145, 158, 171, 0.14),0px 5px 24px 4px rgba(145, 158, 171, 0.12)",
		"0px 7px 9px -4px rgba(145, 158, 171, 0.2),0px 14px 21px 2px rgba(145, 158, 171, 0.14),0px 5px 26px 4px rgba(145, 158, 171, 0.12)",
		"0px 8px 9px -5px rgba(145, 158, 171, 0.2),0px 15px 22px 2px rgba(145, 158, 171, 0.14),0px 6px 28px 5px rgba(145, 158, 171, 0.12)",
		"0px 8px 10px -5px rgba(145, 158, 171, 0.2),0px 16px 24px 2px rgba(145, 158, 171, 0.14),0px 6px 30px 5px rgba(145, 158, 171, 0.12)",
		"0px 8px 11px -5px rgba(145, 158, 171, 0.2),0px 17px 26px 2px rgba(145, 158, 171, 0.14),0px 6px 32px 5px rgba(145, 158, 171, 0.12)",
		"0px 9px 11px -5px rgba(145, 158, 171, 0.2),0px 18px 28px 2px rgba(145, 158, 171, 0.14),0px 7px 34px 6px rgba(145, 158, 171, 0.12)",
		"0px 9px 12px -6px rgba(145, 158, 171, 0.2),0px 19px 29px 2px rgba(145, 158, 171, 0.14),0px 7px 36px 6px rgba(145, 158, 171, 0.12)",
		"0px 10px 13px -6px rgba(145, 158, 171, 0.2),0px 20px 31px 3px rgba(145, 158, 171, 0.14),0px 8px 38px 7px rgba(145, 158, 171, 0.12)",
		"0px 10px 13px -6px rgba(145, 158, 171, 0.2),0px 21px 33px 3px rgba(145, 158, 171, 0.14),0px 8px 40px 7px rgba(145, 158, 171, 0.12)",
		"0px 10px 14px -6px rgba(145, 158, 171, 0.2),0px 22px 35px 3px rgba(145, 158, 171, 0.14),0px 8px 42px 7px rgba(145, 158, 171, 0.12)",
		"0px 11px 14px -7px rgba(145, 158, 171, 0.2),0px 23px 36px 3px rgba(145, 158, 171, 0.14),0px 9px 44px 8px rgba(145, 158, 171, 0.12)",
		"0px 11px 15px -7px rgba(145, 158, 171, 0.2),0px 24px 38px 3px rgba(145, 158, 171, 0.14),0px 9px 46px 8px rgba(145, 158, 171, 0.12)",
		{
			header: "0 2px 4px 0 rgba(0, 0, 0, 0.1)",
			z1: "0 1px 2px 0 rgba(145, 158, 171, 0.24)",
			z8: "0 8px 16px 0 rgba(145, 158, 171, 0.24)",
			z12: "0 0 2px 0 rgba(145, 158, 171, 0.24), 0 12px 24px 0 rgba(145, 158, 171, 0.24)",
			z16: "0 0 2px 0 rgba(145, 158, 171, 0.24), 0 16px 32px -4px rgba(145, 158, 171, 0.24)",
			z20: "0 0 2px 0 rgba(145, 158, 171, 0.24), 0 20px 40px -4px rgba(145, 158, 171, 0.24)",
			z24: "0 0 4px 0 rgba(145, 158, 171, 0.24), 0 24px 48px 0 rgba(145, 158, 171, 0.24)",
			primary: "0 8px 16px 0 rgba(0, 171, 85, 0.24)",
			info: "0 8px 16px 0 rgba(24, 144, 255, 0.24)",
			success: "0 8px 16px 0 rgba(84, 214, 44, 0.24)",
			warning: "0 8px 16px 0 rgba(255, 193, 7, 0.24)",
			error: "0 8px 16px 0 rgba(255, 72, 66, 0.24)"
		}
	],
	shape: {
		borderRadius: 8
	},
	overrides: {
		MuiCssBaseline: {
			"@global": {
				html: {
					"--palette-primary-main": "#9B8678"
				}
			}
		},
		MuiButton: {
			root: {
				borderRadius: "0",
				boxShadow: "none !important",
				padding: "12px 16px"
			},
			outlined: {
				padding: "12px 16px"
			},
			sizeSmall: {
				fontSize: "1rem",
				padding: "8px 16px"
			},
			sizeLarge: {
				fontSize: "1.2rem",
				padding: "16px"
			}
		},
		MuiAutocomplete: {
			endAdornment: {
				marginRight: "16px"
			}
		}
	},
	zIndex: {
		image: {
			overlay: 2,
			content: 3
		},
		bookmark: 4,
		text: 900,
		fabButton: 1000,
		socialMedia: 1100,
		footer: 1200,
		fabButtonInFooter: 1210,
		menuForm: 1220,
		header: 1300,
		drawer: 1500,
		overlay: 1600,
		loader: 1700
	},
	customTypography: {
		h7: {
			fontSize: "clamp(1.2rem, 8vw, 2.8rem)",
			fontWeight: 700,
			lineHeight: 1
		},
		infoLabel: {
			color: "#9B8678",
			fontWeight: 700
		},
		allergensLabel: {
			fontSize: "0.6rem"
		},
		allergensExcludeLabel: {
			fontSize: "0.7rem"
		},
		infoAZLabel: {
			fontSize: "0.875rem",
			fontWeight: 700
		},
		teamDepartmentTitle: {
			color: "#9B8678",
			fontSize: 24,
			fontWeight: 700,
			margin: "40px 0",
			"& span": {
				borderBottom: "1px solid #c5b58d",
				display: "inline-block",
				padding: "0 0 3px"
			}
		},
		teamEmployeeTitle: {
			color: "#9B8678",
			fontSize: 20,
			fontWeight: 700
		},
		ratingTitle: {
			color: "#9B8678",
			fontSize: 18,
			fontWeight: 700,
			"& span": {
				borderBottom: "1px solid #9B8678",
				display: "inline-block",
				padding: "0 0 3px"
			}
		},
		loadingText: {
			color: "#FFFFFF",
			fontSize: "clamp(16px, 2vw, 24px)",
			fontWeight: 600
		},
		languageTitle: {
			color: "#9B8678",
			fontSize: 24,
			fontWeight: 700
		}
	}
};
